/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Pick_BodyInputs */

const en_landing_how_pick_body = /** @type {(inputs: Landing_How_Pick_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every open hour is on the page.`)
};

const pl_landing_how_pick_body = /** @type {(inputs: Landing_How_Pick_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda wolna godzina jest na stronie.`)
};

/**
* | output |
* | --- |
* | "Every open hour is on the page." |
*
* @param {Landing_How_Pick_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_pick_body = /** @type {((inputs?: Landing_How_Pick_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Pick_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_pick_body(inputs)
	return en_landing_how_pick_body(inputs)
});